module.exports = __webpack_public_path__ + "img/address.317fadde.png";